import { IChangeTracking } from "../../../changeTracking/iChangeTracking";

export class RequestShipment implements IChangeTracking {
    private _current: any;

    constructor(private _model: any) {
        this._current = this._model ? angular.copy(this._model) : {};
        this._current.requestedDeliveryDate = this._current.requestedDeliveryDate !== undefined && this._current.requestedDeliveryDate !== null ? new Date(this._current.requestedDeliveryDate.toLocaleString()) : undefined;
        this._current.shipmentReadyDate = this._current.shipmentReadyDate !== undefined && this._current.shipmentReadyDate !== null ? new Date(this._current.shipmentReadyDate.toLocaleString()) : undefined;
        if (this._current.requestedDeliveryDate !== undefined && this._current.requestedDeliveryDate !== null) {
            this._maxShipmentReadyDate = angular.copy(this._current.requestedDeliveryDate);
            this._maxShipmentReadyDate.setDate(this._maxShipmentReadyDate.getDate() - 1);
        }

    }

    get contactName(): string {
        return this._current.contactName;
    }
    set contactName(value: string) {
        this._current.contactName = value;
    }

    get contactPhoneNumber(): string {
        return this._current.contactPhoneNumber;
    }
    set contactPhoneNumber(value: string) {
        this._current.contactPhoneNumber = value;
    }

    get location(): string {
        return this._current.location;
    }
    set location(value: string) {
        this._current.location = value;
    }

    get transportMode(): string {
        return this._current.transportMode;
    }
    set transportMode(value: string) {
        this._current.transportMode = value;
    }
    private _maxShipmentReadyDate:Date;
    get maxShipmentReadyDate(): Date {
        
        return this._maxShipmentReadyDate;
    }
    set maxShipmentReadyDate(value: Date) {
        this._maxShipmentReadyDate = value;
    }

    
    get submittedDate(): string {
       
        if (this._current.submittedDate !== undefined && this._current.submittedDate !== null) {
            return this.getFormattedDateWithAmPm(new Date(this._current.submittedDate));
        }
        return undefined;
        
    }
    
     /// Datetime Formate in dd/mm/yyyy HH:MM AM
     private getFormattedDateWithAmPm(dateValuetobeFormatted: Date): string {
        var monthValue = dateValuetobeFormatted.getMonth() + 1;
        var dateValue = dateValuetobeFormatted.getDate();
        var yearValue = dateValuetobeFormatted.getFullYear();
        var hourValue = dateValuetobeFormatted.getHours();
        var minValue = dateValuetobeFormatted.getMinutes();
        var ampm = hourValue >= 12 ? 'PM' : 'AM';
        hourValue = hourValue % 12;
        hourValue = hourValue ? hourValue : 12;
        return monthValue + "/" + dateValue + "/" + yearValue + " " + this.leftPad(hourValue , 2) + ":" + this.leftPad(minValue,2)
            + " " + ampm;
    }

     private leftPad(num: number, size: number): string {
         var s = num + "";
         while (s.length < size) s = "0" + s;
         return s;
     }


     //requestedDeliveryDate: Date = new Date(this._current.requestedDeliveryDate);
    //shipmentReadyDate: Date;


     get requestedDeliveryDate(): Date {
        return this._current.requestedDeliveryDate;

     }

    set requestedDeliveryDate(value: Date) {   
        this._current.requestedDeliveryDate = value;   
     }

    get shipmentReadyDate(): Date {
        return this._current.shipmentReadyDate;

    }

    set shipmentReadyDate(value: Date) {
        this._current.shipmentReadyDate = value;
    }


    get userName(): string {
        return this._current.userName;
    }

    get additionalFreightCharges(): number {
        return this._current.additionalFreightCharges;
    }

    set additionalFreightCharges(value: number) {
        this._current.additionalFreightCharges = value;
    }

   

    

    get additionalPackagingFees(): number {
        return this._current.additionalPackagingFees;
    }

    set additionalPackagingFees(value: number) {
        this._current.additionalPackagingFees = value;
    }

    get chargeToConsignee(): boolean {
        return this._current.chargeToConsignee;
    }

    set chargeToConsigneeValue(value: string) {
        if (value === undefined) {
            this._current.chargeToConsignee = undefined;
        }
        else {
            if (value === "Yes") {
                this._current.chargeToConsignee = true;

            } else {
                this._current.chargeToConsignee = false;
            }  
        }
        
    }

    get chargeToConsigneeValue(): string {
    if (this.chargeToConsignee === undefined) {
        return undefined;
      }
        return this.chargeToConsignee ? "Yes" : "No";

    }

    get isAsset(): boolean {
        return this._current.isAsset;
    }

    set isAssetValue(value: string) {
        if (value === undefined) {
            this._current.isAsset = undefined;
        }
        else {
            if (value === "Yes") {
                this._current.isAsset = true;

            } else {
                this._current.isAsset = false;
            }
        }

    }

    get isAssetValue(): string {
        if (this.isAsset === undefined) {
            return undefined;
        }
        return this.isAsset ? "Yes" : "No";

    }

    get isFAMR(): boolean {
        return this._current.isFAMR;
    }

    set isFAMRValue(value: string) {
        if (value === undefined) {
            this._current.isFAMR = undefined;
        }
        else {
            if (value === "Yes") {
                this._current.isFAMR = true;

            } else {
                this._current.isFAMR = false;
            }
        }

    }

    get isFAMRValue(): string {
        if (this.isFAMR === undefined) {
            return undefined;
        }
        return this.isFAMR ? "Yes" : "No";

    }



    get additionalInstruction(): string {
        return this._current.additionalInstruction;
    }

    set additionalInstruction(value: string) {
        this._current.additionalInstruction = value;
    }

    get generalLedger(): string {
        return this._current.generalLedger;
    }

    set generalLedger(val: string) {
        this._current.generalLedger = val;
    }

    get costCenter(): string {
        return this._current.costCenter;
    }

    set costCenter(val: string) {
        this._current.costCenter = val;
    }

    hasChanges(): boolean {
        return !angular.equals(this._current, this._model);
    }

    revert(): void {
        this._current = angular.copy(this._model);
        
    }

    commit(): void {
        
        this._model = angular.copy(this._current);
    }

    toJson(): any {
        
        return this._current;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/models/requestShipment.ts
 **/